import { MentionPurpose } from '@common/interfaces/mentions'
import { IMentionSuggestion } from 'src/components/Common/Mentions'
import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'mentions'

const LIST_MENTION_SUGGESTIONS = createRequestTypes(prefix, 'LIST_MENTION_SUGGESTIONS')

export const [
  LIST_MENTION_SUGGESTIONS_REQUEST,
  LIST_MENTION_SUGGESTIONS_SUCCESS,
  LIST_MENTION_SUGGESTIONS_FAILURE,
] = LIST_MENTION_SUGGESTIONS

export const listMentionSuggestions = createAction(
  (params: { name?: string; purpose?: MentionPurpose } = {}) => ({
    type: LIST_MENTION_SUGGESTIONS,
    promise: (api: IApi) =>
      api.mentions.listSuggestions(params) as Promise<{
        data: IMentionSuggestion[]
      }>,
    params,
  }),
)
